module.exports = __webpack_public_path__ + "img/bcg-logo.f0d76204.svg";